// extracted by mini-css-extract-plugin
module.exports = {"previousButton":"az_jMc","previousButtonImage":"az_kMc","nextButton":"az_lMc"};